module.exports = __webpack_public_path__ + "img/home_banner.fd8d1ad0.png";